import React from "react";
import psicopedagogaImage from '../../assets/images/servicos/psicopedagoga.jpg';

const Psicopedagogia = () => {
    return (
        <>
            <section className="breadcrumb-section">
                <div className="container">
                    <h1>Psicopedagogia</h1>
                    <div className="breadcrumb">
                        <a href="/home">Home</a>
                        <span className="fa fa-angle-double-right"></span>
                        <span className="current">Psicopedagogia</span>
                    </div>
                </div>
            </section>

            <div id="main">
                <div className="container">
                    <section id="primary" className="with-sidebar">
                        <article className="blog-entry">
                            <div className="blog-entry-inner">
                                <div className="entry-thumb">
                                    <img src={psicopedagogaImage} alt="Psicopedagogia" />
                                </div>
                                <div className="entry-details">
                                    <div className="entry-title">
                                        <h3> O que é a psicopedagogia? </h3>
                                    </div><br />
                                    <div className="entry-body">
                                        <p>É uma área que se dedica a estudar o processo de aprendizagem e a tratar problemas de aprendizagem e comportamento.</p><br />
                                        <p>O objetivo é compreender as dificuldades de aprendizagem e intervir para que o indivíduo possa desenvolver habilidades e alcançar seu potencial pleno.</p><br />
                                        <p>O trabalho do psicopedagogo envolve avaliação (que contempla diversos aspectos como desenvolvimento motor, cognitivo, linguagem, raciocínio lógico-matemático, entre outros), orientação, plano de intervenção, etc.</p><br />
                                        <p><b>O psicopedagogo pode tratar problemas de aprendizagem e comportamento como: TDAH, Dificuldades de leitura e escrita, Dislexia, Dificuldades de atenção e concentração, Dificuldades de memória e organização.</b></p>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </section>

                    <section id="secondary">
                    </section>
                </div>
            </div>
        </>
    );
};

export default Psicopedagogia;
